import { OrderBoard } from '../components/OrderBoard';

export function KitchenPage() {
  return <OrderBoard station="cozinha" titleKey="kitchen.title" />;
}
